import React from "react";

import { TextField, makeStyles, MenuItem } from "@material-ui/core";

const useStyles = (searchColor) =>
  makeStyles((theme) => ({
    textField: {
      fontSize: "12px !important",
      width: "100%",
      [`& fieldset`]: {
        borderRadius: theme.spacing(4),
        border: searchColor && "1px solid rgba(226, 19, 110, 1)",
        background: searchColor && "rgba(226, 19, 110, 0.04)",
      },

      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
        background: "white",
        padding: 4,
        borderRadius: 5,
        transform: "translate(14px, -11px) scale(.9)",
        fontSize: "12px !important",
        color: searchColor && "rgba(226, 19, 110, 1)",
      },

      "& .MuiInputBase-root": {
        "& .MuiOutlinedInput-notchedOutline": {
          "& legend": {
            maxWidth: 0,
          },
        },
      },
    },
    textFieldInput: {
      fontSize: "12px !important",
      minHeight: 20,
      borderRadius: "32px !important",
      background: "white !important",
    },
    textFieldLabel: {
      textAlign: "initial",
      fontSize: "14px !important",
      margin: 0,
      fontFamily: "Inter",
    },
  }));

export default function SelectInput({
  value,
  endAdornment,
  startAdornment,
  searchColor,
  options,
  ...rest
}) {
  const classes = useStyles(searchColor)();

  return (
    <TextField
      variant="outlined"
      value={value || ""}
      margin="normal"
      fullWidth
      autoComplete="off"
      className={classes.textField}
      InputLabelProps={{
        className: classes.textFieldLabel,
        // shrink: true,
      }}
      InputProps={{
        startAdornment: startAdornment,
        endAdornment: endAdornment,
        classes: {
          input: classes.textFieldInput,
        },
      }}
      {...rest}
      select
    >
      {options.map(({ label, value }) => (
        <MenuItem key={value} value={value}>
          {label}
        </MenuItem>
      ))}
    </TextField>
  );
}
